import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import style from './style.module.scss';

const ENTER_KEY = 13;

/**
 * CloseButton:
 *  - CloseButton for Modal Component
 */
export function CloseButton(props) {

  const {t} = useTranslation();

  const onKeyDown = (event) =>
    event.keyCode === ENTER_KEY && props.close(event);

  const className = `${style.btn} ${props.className}_closeBtn`;

  return (
      <div
        className={className}
        tabIndex='0'
        role='button'
        onClick={props.close}
        onKeyDown={onKeyDown}>
        <svg
          width='18'
          height='18'
          viewBox='0 0 18 18'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <circle cx='9' cy='9' r='9' fill='#CCD8E1' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M13 13C12.8048 13.1952 12.4882 13.1952 12.2929 13L5.00004 5.70707C4.80478 5.51181 4.80478 5.19522 5.00004 4.99996V4.99996C5.1953 4.8047 5.51188 4.8047 5.70714 4.99996L13 12.2929C13.1953 12.4881 13.1953 12.8047 13 13V13Z'
            fill='#003E6B'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M5.00004 13C4.80478 12.8048 4.80477 12.4882 5.00004 12.2929L12.2929 5.00004C12.4882 4.80478 12.8048 4.80478 13 5.00004V5.00004C13.1953 5.1953 13.1953 5.51188 13 5.70714L5.70714 13C5.51188 13.1953 5.1953 13.1953 5.00004 13V13Z'
            fill='#003E6B'
          />
        </svg>
        <span>{t("Close.string")}</span>
      </div>
  );
}

CloseButton.propTypes = {
  /**
   * custom className to set for closeButton
   */
  className: PropTypes.string.isRequired,
  /**
   * callback function to be involked close button is clicked
   */
  close: PropTypes.func,
  /**
   * String value to specify the size of modal
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

CloseButton.defaultProps = {
  className: '',
  size: 'sm',
};
